module.exports = __webpack_public_path__ + "static/img/英文版平面图.1e20afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/英文版平面图.png
// module id = jCiq
// module chunks = 1